export const fieldsUseNewJsonForm = [
    'coverage.lenderServicingAddress',
    'coverage.certificateHolderAddress',
];
